import React from "react";

const ServiceCard = ({ title, text, img }) => {
  return (
    <div
      className="group relative rounded-[22px] m-1
     p-4 sm:p-6 lg:p-8 flex flex-col sm:flex-row items-center gap-8 
      hover:shadow-[0_20px_60px_rgba(138,63,184,0.06)] 
      bg-gradient-to-bl from-[#f2e9f2] via-[#f2edf2] to-[#f2e9f2]
      transition-all duration-700 overflow-hidden"
    >
      {/* افکت دکوراتیو پس‌زمینه */}
      <div
        className="absolute top-0 right-0 w-40 h-40 
      bg-gradient-to-bl from-purple/5 to-transparent rounded-bl-full
       pointer-events-none transition-transform duration-700 group-hover:scale-105"
      ></div>

      {/* بخش تصویر (آیکون) - بدون کشیدگی و در یک کادر شیک */}
      <div
        className="flex-shrink-0 w-[60px]  h-[60px] sm:w-36 sm:h-36
       bg-purple/5 rounded-[18px] lg:rounded-[22px] flex items-center justify-center
        relative overflow-hidden  transition-colors duration-500"
      >
        <div
          className="absolute inset-0 border-2 border-purple/10 
        rounded-[18px] lg:rounded-[22px] scale-95 group-hover:scale-100 transition-transform duration-700"
        ></div>
        <img
          src={img}
          alt={title}
          className="w-8 h-8 lg:w-12 lg:h-12 sm:w-16 sm:h-16 object-contain relative
           z-10  transition-all
            duration-500 group-hover:scale-105"
        />
      </div>

      {/* بخش محتوا - سبک مجله‌ای */}
      <div className="flex flex-col flex-1 text-center sm:text-right z-10 -mt-5 lg:mt-0">
        <h4
          className="lg:text-[18px] text-[14px] font-extrabold text-gray-800
    group-hover:text-purple transition-colors duration-500 mb-1 lg:mb-2"
        >
          {title}
        </h4>

        <p
          className="text-gray-500 text-[12px] sm:text-[13px] lg:text-[14px]
    leading-[20px] lg:leading-[28px] line-clamp-2 min-h-[50px] lg:min-h-[55px]"
        >
          {text}
        </p>

        <div
          className="w-12 h-1 bg-purple/20 rounded-full mt-2 lg:mt-6
    group-hover:w-24 transition-all duration-700 mx-auto sm:mx-0"
        />
      </div>
    </div>
  );
};

export default ServiceCard;
